// extracted by mini-css-extract-plugin
export default {"divider":"login_divider__DHF0p","h_custom":"login_h_custom__HYS65"};